import { render, staticRenderFns } from "./PedidoForm.vue?vue&type=template&id=21a850de"
import script from "./PedidoForm.vue?vue&type=script&lang=js"
export * from "./PedidoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports